if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this._fetch = (window.__realFetch || window.fetch).bind(window);
      this._cooldownActive = false;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (this._cooldownActive) return;
      this._cooldownActive = true;
      var self = this;
      setTimeout(function() { self._cooldownActive = false; }, 2000);

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(function(section) { return section.id; }));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      this._fetch(routes.cart_add_url, config)
        .then(function(response) {
          if (response.status === 429) {
            console.warn('Add to cart rate limited. Waiting 3s before retry.');
            return new Promise(function(resolve) {
              setTimeout(resolve, 3000);
            }).then(function() {
              return self._fetch(routes.cart_add_url, config);
            }).then(function(retryResponse) {
              return retryResponse.json();
            });
          }
          return response.json();
        })
        .then(function(response) {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            self.handleErrorMessage(response.description);

            var soldOutMessage = self.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            self.submitButton.setAttribute('aria-disabled', true);
            self.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            self.error = true;
            return;
          } else if (!self.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          self._pushAddToCartTracking(response);
          self._updateDataLayerCart();

          if (!self.error) publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id')
          });
          self.error = false;

          var quickAddModal = self.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', function() {
              setTimeout(function() { self.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            self.cart.renderContents(response);
          }
        })
        .catch(function(e) {
          console.error('Add to cart error:', e);
        })
        .finally(function() {
          self.submitButton.classList.remove('loading');
          if (self.cart && self.cart.classList.contains('is-empty')) self.cart.classList.remove('is-empty');
          if (!self.error) self.submitButton.removeAttribute('aria-disabled');
          self.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    _pushAddToCartTracking(response) {
      if (!window.dataLayer) return;

      var items = response.items || [response];
      var prefix = 'sha_';
      var currency = 'NZD';

      try {
        if (window.shopifyDataLayer && window.shopifyDataLayer.cart) {
          currency = window.shopifyDataLayer.cart.currency || 'NZD';
        }
      } catch (e) {}

      items.forEach(function(item) {
        var eventId = 'eid.' + Date.now() + '.' + Math.random().toString(36).substring(2, 12);
        var price = item.final_price ? parseFloat((item.final_price / 100).toFixed(2)) :
                    item.price ? parseFloat((item.price / 100).toFixed(2)) : 0;

        var isPreorder = false;
        var itemSize = '';
        try {
          if (window.shopifyDataLayer && window.shopifyDataLayer.variantInventoryMap) {
            var inv = window.shopifyDataLayer.variantInventoryMap[item.variant_id];
            if (inv) isPreorder = inv.isPreorder;
          }
          if (window.shopifyDataLayer && window.shopifyDataLayer.extractSize) {
            itemSize = window.shopifyDataLayer.extractSize(item.variant_title);
          }
        } catch (e) {}

        var ecommerceItem = {
          index: 0,
          item_id: item.product_id ? item.product_id.toString() : '',
          product_id: item.product_id ? item.product_id.toString() : '',
          variant_id: item.variant_id ? item.variant_id.toString() : '',
          item_name: item.product_title || item.title || '',
          quantity: item.quantity || 1,
          price: price,
          discount: item.total_discount ? parseFloat((item.total_discount / 100).toFixed(2)) : 0,
          item_brand: item.vendor || '',
          item_category: item.product_type || '',
          item_size: itemSize,
          item_preorder_status: isPreorder ? 'preorder' : 'in_stock'
        };

        if (item.sku) ecommerceItem.sku = item.sku;
        if (item.variant_title && item.variant_title !== 'Default Title') {
          ecommerceItem.item_variant = item.variant_title;
        }

        var eventData = {
          event: prefix + 'add_to_cart',
          event_id: eventId,
          ecommerce: {
            currency: currency,
            value: parseFloat((price * (item.quantity || 1)).toFixed(2)),
            items: [ecommerceItem]
          },
          cart_type: isPreorder ? 'preorder_only' : 'in_stock_only',
          has_preorder: isPreorder,
          is_preorder: isPreorder
        };

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(eventData);

        // Full data log so you can verify what GTM receives
        console.log(
          '%cProduct Form → GTM:%c' + prefix + 'add_to_cart',
          'background:green;color:#fff;padding:2px 4px;border-radius:3px 0 0 3px;',
          'background:blue;color:#fff;padding:2px 4px;border-radius:0 3px 3px 0;'
        );
        console.log('  Full dataLayer push:', JSON.parse(JSON.stringify(eventData)));
      });
    }

    _updateDataLayerCart() {
      var realFetch = (window.__realFetch || window.fetch).bind(window);
      setTimeout(function() {
        realFetch('/cart.js')
          .then(function(r) {
            if (!r.ok) return;
            return r.json();
          })
          .then(function(cart) {
            if (!cart) return;
            try {
              if (window.shopifyDataLayer) window.shopifyDataLayer.cart = cart;
            } catch (e) {}
          })
          .catch(function() {});
      }, 2000);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}